import type { Timer } from './_types';
import { DateLike, SlugDate } from '../datetime';
import { max } from './math';

export * from './func';
export * from './sync';
export * from './math';
export * from './promise';

// 防抖
export const debounce = <T extends (this: K, ...args: any) => void, K = any>(fn: T, delay = 0) => {
  let timer: Timer;
  return function (this: K, ...args: Parameters<T>) {
    clearTimeout(timer);
    timer = setTimeout(() => fn.apply(this, args), delay);
  };
};

// 节流
export const throttle = <T extends (this: K, ...args: any) => void, K = any>(fn: T, delay = 0) => {
  let able = true;
  return function (this: K, ...args: Parameters<T>) {
    if (!able) {
      return;
    }
    fn.apply(this, args);
    able = false;
    setTimeout(() => able = true, delay);
  };
};

// TODO: 进度条

// === 倒计时 ===

// // 线程占用
// setInterval(() => {
//   let j = 0;
//   while (j++ < 100000000);
// }, 0);

export interface CountDownOptions {
  start?: DateLike
  end: DateLike
  interval?: number
  callback?: (duration: number) => void
}

export const countDown = ({
  start = new SlugDate(),
  end,
  interval = 1000,
  callback,
}: CountDownOptions) => {
  if (interval <= 0) {
    return;
  }
  const s = new SlugDate(start).getTime();
  const e = max(new SlugDate(end).getTime(), s); // e >= s
  const duration = e - s;
  if (duration <= 0) {
    callback?.(0);
    return;
  }

  // let count = 0;
  // let timer: Timer;
  // let ms = duration;
  // const task2 = () => {
  //   count++;
  //   const offset = new SlugDate().getTime() - (s + count * interval);
  //   const nextTime = max(interval - offset, 0);
  //   ms -= interval;
  //   console.log(`误差：${offset}ms，下一次执行：${nextTime}ms后，离活动开始还有：${ms}ms`);
  //   callback?.(ms);
  //   ms <= 0 ? clearTimeout(timer) : (timer = setTimeout(task, nextTime));
  // };
  // timer = setTimeout(task2, 0);

  const task = () => {
    const now = new SlugDate().getTime();
    const duration = max(e - now, 0);
    const nextTime = duration % interval || interval; // 1~interval
    // console.log(`开始时间${end}, 下一次执行：${duration > 0 ? nextTime : 0}ms后，离开始还有：${duration}ms`);
    callback?.(duration);
    duration > 0 && setTimeout(task, nextTime);
  };
  setTimeout(task, 0);
};

export const afterCountDown = ({ callback: cb, ...opts }: CountDownOptions) => new Promise((r) => {
  countDown({ ...opts, callback(duration) {
    cb?.(duration);
    duration === 0 && r();
  } });
});
